import React, { useContext, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';

import { I18nContext } from '@bingads-webui-react/i18n-context';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { GoalSelector } from '@bingads-webui-campaign-react/goal-selector-v2';
import { buildLegacyI18n } from '@bingads-webui/build-legacy-i18n';
import { mergeI18n } from '@bingads-webui-campaign-react/i18n-merger';
import { useP$DaterangeDefault, ConversionGoalKeyToStringMapping } from '@bingads-webui-campaign-react/wizard-shared-components';

export const ConversionGoals = ({ data, onDataChange }) => {
  const i18n = useContext(I18nContext);

  const legacyI18n = useMemo(() => buildLegacyI18n(
    i18n,
    [ConversionGoalKeyToStringMapping]
  ), [i18n]);

  const mergedI18n = useMemo(() => mergeI18n(legacyI18n, i18n), [i18n, legacyI18n]);

  const $dateRange = useP$DaterangeDefault();

  const serverContext = useContext(ServerContext);
  const aid = useMemo(() => serverContext.CurrentAccount.Id, [serverContext]);
  const cid = useMemo(() => serverContext.CurrentAccount.AdvertiserCustomerID, [serverContext]);

  const onRenderLabel = useCallback(() => (
    <div className="custom-label-view">
      {i18n.getString(_TL_('Measure the actions that people  take on your website after clicking or viewing your ad on LinkedIn.'))}
    </div>
  ), [i18n]);

  return (
    <GoalSelector
      className="goal-selector"
      i18n={mergedI18n}
      selectedGoals={Array.isArray(data) ? data : []}
      pageSize={60}
      $dateRange={$dateRange}
      cid={cid}
      aid={aid}
      resultsTitle={i18n.getString(_TL_('LinkedIn compatible conversion goals'))}
      onChange={onDataChange}
      isLinkedInCompatibleGoals
      showTrackingStatusIcon
      onRenderLabel={onRenderLabel}
    />
  );
};

ConversionGoals.propTypes = {
  data: PropTypes.shape({}).isRequired,
  onDataChange: PropTypes.func.isRequired,
};
